import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PageMoveService } from 'src/app/service/page-move.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ApiService } from 'src/app/service/api.service';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { data } from 'jquery';

@Component({
  selector: 'app-admin-notice-edit',
  templateUrl: './admin-notice-edit.component.html',
  styleUrls: ['./admin-notice-edit.component.css']
})
export class AdminNoticeEditComponent implements OnInit {

  public Editor = ClassicEditor

  notice: {[index: string]:any}={
    title:"",
    content:"",
    file: "",
    part: "알림"
  }


  previewFlag:boolean =false;
  
  constructor( 
    private pageMove:PageMoveService,
    private location:Location,
    private apiService:ApiService
  ){ 
  }


  ngOnInit(): void {
  
    if(this.pageMove.notice !==null){
      this.notice = this.pageMove.notice;
    }
  }
 
  activePreview(){
    this.previewFlag = true;
  }
  unactivePreview(event:boolean){
    this.previewFlag = event;
  }

  handleChange(event:any){
    this.notice[event.target.name]=event.target.value;
  }

  onChange( { editor }: ChangeEvent ){
    this.notice.content = editor.getData();
  }

  rollBack(){
    this.location.back();
  }

  submit(){
    if(this.notice.id === undefined){
      this.apiService.createNoticeData(this.notice)
      .then((resp)=>{
        console.log(resp);
        this.pageMove.goPage('/admin/notice');
      })
      .catch((err)=>{
        console.log(err);
      })
    }
    else{
      this.apiService.setNoticeData(this.notice)
      .then(()=>{
        this.pageMove.goPage('/admin/notice');
      })
      .catch((err)=>{
        console.log(err);
      })
    }
  }
}
